/**
 * muiThemeConfig.js — CONFIG MUI PINADA (imutável no fluxo de design).
 *
 * FONTE ÚNICA do ambiente de render, compartilhada por:
 *   - o Admin (App.jsx monta o tema real com isto),
 *   - o `design-package` (o `build:design` copia isto pro pacote).
 *
 * Assim **pacote == Admin** (mesmo MUI, mesma tipografia, mesmos defaults de componente) → a View
 * renderiza idêntica nos dois. O canvas do Claude Design é só a mesa de desenho; a VALIDAÇÃO de
 * fidelidade é o pacote rodável (MUI real). Ícones: SEMPRE `@mui/icons-material` (SVG), imutável.
 *
 * ⚠️ Este é o ambiente que o CD deve assumir. Está escrito no brief do design-package como
 *    OBRIGATÓRIO. Não trocar versão de MUI nem set de ícones sem alinhar os dois lados.
 */
export const muiThemeConfig = {
  typography: {
    // Herda a fonte do designer (var setada pelo tema em runtime).
    fontFamily: 'var(--font-family)',
    // line-height `normal` (~1.2) — espelha como o texto se comporta sem override; o `sx`
    // explícito da View sempre vence. (MUI default 1.5/1.66 "afastava" label/hint.)
    body1: { lineHeight: 'normal' },
    body2: { lineHeight: 'normal' },
    subtitle1: { lineHeight: 'normal' },
    subtitle2: { lineHeight: 'normal' },
    caption: { lineHeight: 'normal', display: 'block' },
    h4: { lineHeight: 'normal' }, h5: { lineHeight: 'normal' }, h6: { lineHeight: 'normal' },
  },
  components: {
    // Densidade padrão do Admin (compacto) — pareia com o que a designer desenhou.
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiSelect: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    // Toggle "chunky" (como o CD renderiza) — o Switch fino default do MUI ficava apertado.
    MuiSwitch: {
      styleOverrides: {
        root: { width: 44, height: 26, padding: 0, display: 'flex' },
        switchBase: { padding: 3, '&.Mui-checked': { transform: 'translateX(18px)' } },
        thumb: { width: 20, height: 20, boxShadow: '0 1px 2px rgba(0,0,0,.2)' },
        track: { borderRadius: 13, opacity: 1, backgroundColor: '#cbd3e1' },
      },
    },
    // Um pouco de respiro vertical por linha (o "levemente mais arejado" do CD).
    MuiFormControlLabel: { styleOverrides: { root: { paddingTop: 6, paddingBottom: 6 } } },
  },
};
